export const USER_PAGE_TOAST = {
  TYPE_SUCCESS: "success",
  TYPE_FAILURE: "failure",
  TITLE_SUCCESS: "Success",
  TITLE_FAILED: "Failed",
  DURATION: 5000,
  platform: {
    inviteSuccess: "Invitation sent successfully.",
    inviteFailure: "Invitation could not be sent. Please try again.",
    saveSuccess: "User access updated successfully.",
    saveFailure: "Changes could not be saved. Please try again.",
    resendSuccess: "Invitation resent successfully.",
    resendFailure: "Resend failed. Please try again.",
    suspendSuccess: "User suspended successfully.",
    suspendFailure: "User could not be suspended. Please try again.",
    restoreSuccess: "User restored successfully.",
    restoreFailure: "User could not be restored. Please try again.",
    unexpectedError: "An unexpected error occurred. Please try again.",
  },
  customer: {
    inviteSuccess: "Invite sent successfully.",
    inviteFailure: "Invite could not be sent. Please try again.",
    rolesSuccess: "Roles updated successfully.",
    rolesFailure: "Role update failed. Please try again.",
    accessRevokeSuccess: "Access revoked successfully.",
    accessRestoreSuccess: "Access restored successfully.",
    accessUpdateFailure: "Update failed. Please try again.",
    resendSuccess: "Invitation resent successfully.",
    resendFailure: "Resend failed. Please try again.",
    missingCustomer:
      "Missing customer identifier. Please select a customer from the header.",
    unexpectedError: "An unexpected error occurred. Please try again.",
  },
};

export const resolveUserPageToastMessage = (error, fallback) => {
  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }
  return fallback;
};
